"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Sizes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sizeContext = require("./sizeContext");
var _sizeOptionHelpers = require("./sizeOptionHelpers");
var _sizeModule = _interopRequireDefault(require("./size.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var propTypes = {
  /** Sizes to be displayed within the list */
  children: _propTypes["default"].node.isRequired,
  /** Name of the group */
  label: _propTypes["default"].string,
  /** Name of the sub label */
  sublabel: _propTypes["default"].string,
  /** Name of the size inputs */
  name: _propTypes["default"].string,
  /** Function to be called when a size is selected */
  onClick: _propTypes["default"].func,
  /** Flag to hide the label  */
  hideLabel: _propTypes["default"].bool,
  /** Custom class name */
  className: _propTypes["default"].string,
  /** Name of the selected size variant */
  selectedLabel: _propTypes["default"].string
};
var defaultProps = {
  sublabel: '',
  label: 'Size',
  name: 'size',
  onClick: function onClick() {},
  buttonSizeThresholds: _sizeOptionHelpers.defaultThresholds,
  hideLabel: false,
  className: ''
};
var Sizes = exports.Sizes = function Sizes(_ref) {
  var children = _ref.children,
    name = _ref.name,
    sublabel = _ref.sublabel,
    label = _ref.label,
    onClick = _ref.onClick,
    hideLabel = _ref.hideLabel,
    className = _ref.className,
    longestLabel = _ref.longestLabel,
    selectedLabel = _ref.selectedLabel;
  var renderedLabel = selectedLabel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectorLabel, {
    label: label,
    selectedLabel: selectedLabel,
    sublabel: sublabel
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
    className: _sizeModule["default"]['c-sizeList__title'],
    "data-testid": "sizelist:label",
    children: label
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _sizeModule["default"]['c-sizeList'],
    children: [hideLabel ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: renderedLabel
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: "".concat(_sizeModule["default"]['c-sizeList__items'], " ").concat(className),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_sizeContext.SizeProvider, {
        value: {
          name: name,
          onClick: onClick,
          longestLabel: longestLabel
        },
        children: children
      })
    })]
  });
};
var SizeList = function SizeList(_ref2) {
  var children = _ref2.children,
    buttonSizeThresholds = _ref2.buttonSizeThresholds,
    onClick = _ref2.onClick,
    name = _ref2.name,
    label = _ref2.label,
    sublabel = _ref2.sublabel,
    hideLabel = _ref2.hideLabel,
    selectedLabel = _ref2.selectedLabel;
  if (_react["default"].Children.count(children) === 0) return null;
  var longestLabel = (0, _sizeOptionHelpers.getSizeCategory)(_react["default"].Children.map(children, function (child) {
    return child.props.children;
  }), buttonSizeThresholds);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Sizes, {
    sublabel: sublabel,
    label: label,
    onClick: onClick,
    name: name,
    longestLabel: longestLabel,
    hideLabel: hideLabel,
    selectedLabel: selectedLabel,
    children: children
  });
};
SizeList.propTypes = {
  /** Sizes to be displayed within the list */
  children: _propTypes["default"].node.isRequired,
  /** Name of the size inputs */
  name: _propTypes["default"].string,
  /** Name of the sublabel */
  sublabel: _propTypes["default"].string,
  /** Function to be called when a size is selected */
  onClick: _propTypes["default"].func,
  /*
   * Using the length of longest label available we decide against these threshold
   * to categorise it as "small", "medium" or "large".
   */
  buttonSizeThresholds: _propTypes["default"].shape({
    small: _propTypes["default"].number,
    medium: _propTypes["default"].number,
    large: _propTypes["default"].number
  }),
  /** Name of the selected size variant */
  selectedLabel: _propTypes["default"].string
};
SizeList.defaultProps = {
  name: 'size',
  onClick: function onClick() {},
  buttonSizeThresholds: _sizeOptionHelpers.defaultThresholds
};
var SelectorLabel = function SelectorLabel(_ref3) {
  var _ref3$label = _ref3.label,
    label = _ref3$label === void 0 ? 'Size' : _ref3$label,
    _ref3$sublabel = _ref3.sublabel,
    sublabel = _ref3$sublabel === void 0 ? '' : _ref3$sublabel,
    selectedLabel = _ref3.selectedLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("h4", {
    className: _sizeModule["default"]['c-sizeList__title'],
    "data-testid": "sizelist:label",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _sizeModule["default"]['c-sizeList__label'],
      children: label + ': '
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _sizeModule["default"]['c-sizeList__selected'],
      children: selectedLabel
    }), sublabel && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: _sizeModule["default"]['c-sizeList__subLabel'],
      children: [" ", sublabel]
    })]
  });
};
SelectorLabel.propTypes = {
  /** Name of the label */
  label: _propTypes["default"].string,
  /** Name of the sublabel */
  sublabel: _propTypes["default"].string,
  /** Name of the selected value */
  selectedLabel: _propTypes["default"].string.isRequired
};
Sizes.propTypes = propTypes;
Sizes.defaultProps = defaultProps;
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SizeList);